// src/utils.js
/* ───────────────────────────────────────── *\
|*                COOKIE UTILS              *|
\* ───────────────────────────────────────── */

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

/*  CSRF-токен кладёт сервер в cookie = COOKIE_NAME.
    В примере бекенда это просто 'csrf_token'. */
export const getCsrfToken = () => getCookie('csrf_token');

export const setCookie = (
  name,
  value,
  days,
  samesite = 'Lax',
  secure = false,
) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  const secureFlag = secure ? '; Secure' : '';
  document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=${samesite}${secureFlag}`;
};

/* Обычно для фронта access-токен не нужен —
   он HttpOnly.  Но оставим, вдруг пригодится. */
export const getAccessToken = () => getCookie('access_token');
